/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import BackgroundImage from "/Images/Background.svg";
import CheckIcon from "/Images/cekidot.svg";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import { MenuItem, Select, Checkbox } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const countryOptions = [
  { code: "+81", name: "Japan", flagUrl: "https://flagcdn.com/w40/jp.png" },
  {
    code: "+1",
    name: "United States",
    flagUrl: "https://flagcdn.com/w40/us.png",
  },
  {
    code: "+44",
    name: "United Kingdom",
    flagUrl: "https://flagcdn.com/w40/gb.png",
  },
  { code: "+62", name: "Indonesia", flagUrl: "https://flagcdn.com/w40/id.png" },
  { code: "+91", name: "India", flagUrl: "https://flagcdn.com/w40/in.png" },
  { code: "+86", name: "China", flagUrl: "https://flagcdn.com/w40/cn.png" },
  { code: "+61", name: "Australia", flagUrl: "https://flagcdn.com/w40/au.png" },
  { code: "+49", name: "Germany", flagUrl: "https://flagcdn.com/w40/de.png" },
  { code: "+33", name: "France", flagUrl: "https://flagcdn.com/w40/fr.png" },
  { code: "+39", name: "Italy", flagUrl: "https://flagcdn.com/w40/it.png" },
  // Add more countries as needed
];

const HeroSection = ({ setOpen }) => {
  const [selectedCode, setSelectedCode] = useState("+62"); // Set default code
  const isMobile = useMediaQuery("(max-width: 770px)");
  const isIpad = useMediaQuery("(max-width: 1024px)");
  const isSmallMobile = useMediaQuery("(max-width: 400px)");
  const [phone, setPhone] = useState("");
  const [checkboxState, setCheckboxState] = useState({
    custody: false,
    xcrow: false,
    otc: false,
  });
  const [dataEmail, setDataEmail] = useState({
    firstname: '',
    lastname: '',
    email: '',
    company_name: '',
    product: '',
    description: ''
  })

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckboxState((prevState) => ({
      ...prevState,
      [name]: checked,
    }));
    setDataEmail((prevData) => ({
      ...prevData,
      product: checked
        ? prevData.product
          ? `${prevData.product}, ${name}`
          : name
        : prevData.product.split(', ').filter((item) => item !== name).join(', '),
    }));
  };

  const scrollToBottom = () => {
    document.getElementById("form-container").scrollTo({
      top: document.getElementById("form-container").scrollHeight,
      behavior: "smooth",
    });
  };

  const CustomCheckbox = styled((props) => (
    <Checkbox
      {...props}
      disableRipple
      sx={{
        color: "#80A4BA",
        "&.Mui-checked": {
          color: "#F4E37B",
        },
      }}
      value={checkboxState}
    />
  ))();

  const styles = {
    button: {
      backgroundColor: "#F4E37B",
      color: "#214D73",
      padding: isMobile ? "10px 20px" : "15px 30px",
      borderRadius: "8px",
      border: "none",
      fontSize: isMobile ? "0.875rem" : "1rem",
      cursor: "pointer",
      textDecoration: "none",
      display: "inline-block",
    },
    formContainer: {
      position: "relative",
      backgroundColor: "rgba(255, 255, 255, 0.05)",
      borderRadius: "12px",
      padding: isMobile ? "1rem" : "2rem",
      maxWidth: isMobile ? "100%" : "550px",
      maxHeight: isMobile ? "100%" : "700px",
      border: "2px solid #719CB7",
      overflowY: "auto",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
    },
    arrowDown: {
      position: "absolute",
      top: "10px",
      right: "10px",
      cursor: "pointer",
      color: "#F4E37B",
      backgroundColor: "#214D73",
      borderRadius: "50%",
      padding: "8px",
      display: isMobile ? "block" : "none",
    },
    label: {
      fontSize: "14px",
      marginBottom: "5px",
    },
    checklist: {
      display: "flex",
      alignItems: "center",
      marginBottom: "10px",
    },
    checkIcon: {
      height: "20px",
      marginRight: "8px",
    },
    checklistText: {
      fontSize: "1rem",
      color: "#FFFFFF",
      margin: 0,
      fontWeight: "600",
    },
    checklistSubtext: {
      fontSize: "1rem",
      color: "#E7E4E2",
      margin: 0,
      maxWidth: "500px",
    },
    input: {
      width: "100%",
      padding: "12px",
      marginTop: "8px",
      borderRadius: "6px",
      border: "1px solid rgba(231, 228, 226, 0.5)",
      backgroundColor: "transparent",
      color: "#FFFFFF",
      fontSize: "14px",
      minHeight: "54.5px",
      boxSizing: "border-box",
    },
    textarea: {
      width: "100%",
      minHeight: "30px",
      padding: "10px",
      marginTop: "4px",
      borderRadius: "6px",
      border: "1px solid rgba(231, 228, 226, 0.5)",
      backgroundColor: "transparent",
      color: "#FFFFFF",
      fontSize: "14px",
      boxSizing: "border-box",
      fontFamily: "poppins",
    },
    row: {
      display: "flex",
      flexDirection: isMobile ? "column" : "row",
      gap: "15px",
      marginBottom: "15px",
      flexWrap: "wrap",
    },
    phoneNumberContainer: {
      display: "flex",
      alignItems: "center",
      border: "1px solid rgba(231, 228, 226, 0.5)",
      borderRadius: "6px",
      padding: "0 4px",
      height: "43px",
      marginTop: "8px",
      backgroundColor: "transparent",
      gap: "0px",
    },
    flagAndDividerContainer: {
      display: "flex",
      alignItems: "center",
      width: "60%",
      justifyContent: "flex-start",
    },
    divider: {
      height: "70%",
      width: "1px",
      backgroundColor: "#FFFFFF",
    },
    phoneInput: {
      border: "none",
      backgroundColor: "transparent",
      color: "#FFFFFF",
      fontSize: "14px",
      height: "100%",
      outline: "none",
    },
    sendButton: {
      backgroundColor: "#F4E37B",
      color: "#214D73",
      padding: "10px 20px",
      borderRadius: "8px",
      border: "none",
      fontSize: "14px",
      cursor: "pointer",
      width: "100%",
      minHeight: "35px",
    },
  };
  const handleCodeChange = (event) => {
    setSelectedCode(event.target.value);
  };

  const handleSendEmail = async () => {
    try {
      const response = await fetch(import.meta.env.VITE_BASE_API || 'https://bd-xcrow.depository.id/api/email-git', {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ phone_number: selectedCode + phone, ...dataEmail }),
      });
      const result = await response.json();
      console.log(result);
      setOpen(true);
      setDataEmail({
        firstname: '',
        lastname: '',
        email: '',
        company_name: '',
        product: '',
        description: ''
      })
      setPhone("")
      setSelectedCode("+62")
      setCheckboxState({
        custody: false,
        xcrow: false,
        otc: false
      })
    } catch (error) {
      console.error("Error sending email:", error);
    }
  };

  return (
    <section
      style={{
        display: "flex",
        flexDirection: isIpad ? "column" : "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        padding: isSmallMobile
          ? "50px 20px"
          : isMobile
            ? "80px 40px"
            : "100px 100px",
        color: "#FFFFFF",
      }}
    >
      {/* Text Content */}
      <div
        style={{
          maxWidth: isIpad ? "100%" : "600px",
          marginBottom: isIpad ? "40px" : "0",
          marginTop: isIpad ? "0" : "8rem",
        }}
      >
        <h1
          style={{
            fontSize: isMobile ? "36px" : "60px",
            fontWeight: 550,
            lineHeight: "1.2",
            marginBottom: "30px",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          <span>Get in</span> <span style={{ color: "#F4E37B" }}>Touch</span>
        </h1>

        <p
          style={{
            fontSize: isMobile ? "18px" : "26px",
            color: "#E7E4E2",
            marginBottom: "20px",
            maxWidth: "582.19px",
          }}
        >
          We provide advanced technology solutions to secure and manage digital
          assets.
        </p>

        {/* Checklist Items */}
        <div>
          {/* Checklist */}
          <div style={styles.checklist}>
            <img src={CheckIcon} alt="Check Icon" style={styles.checkIcon} />
            <div>
              <p style={styles.checklistText}>Defense In-depth Security</p>
              <p style={styles.checklistSubtext}>
                Hardware + software + fraud detection. Secured by HSM FIPS 140-2
                Level 3
              </p>
            </div>
          </div>

          <div style={styles.checklist}>
            <img src={CheckIcon} alt="Check Icon" style={styles.checkIcon} />
            <div>
              <p style={styles.checklistText}>Large Choice of Use Cases</p>
              <p style={styles.checklistSubtext}>
                Secure wallet infrastructure, asset servicing for tokenized
                securities
              </p>
            </div>
          </div>

          <div style={styles.checklist}>
            <img src={CheckIcon} alt="Check Icon" style={styles.checkIcon} />
            <div>
              <p style={styles.checklistText}>
                Rapid integration, flexible deployment
              </p>
              <p style={styles.checklistSubtext}>
                10 days of integration. On premise, SaaS, or hybrid
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <div id="form-container" style={styles.formContainer}>
        {/* Arrow Down Icon */}
        <ArrowDownwardIcon onClick={scrollToBottom} style={styles.arrowDown} />

        <form>
          {/* First Name and Last Name */}
          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>First name *</label>
              <input
                type="text"
                placeholder="First name"
                required
                style={styles.input}
                value={dataEmail.firstname}
                onChange={(e) => setDataEmail((prevState) => ({
                  ...prevState,
                  firstname: e.target.value,
                }))}
              />
            </div>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Last name *</label>
              <input
                type="text"
                placeholder="Last name"
                required
                style={styles.input}
                value={dataEmail.lastname}
                onChange={(e) => setDataEmail((prevState) => ({
                  ...prevState,
                  lastname: e.target.value,
                }))}
              />
            </div>
          </div>

          {/* Email and Phone Number */}
          <div style={styles.row}>
            <div style={{ flex: 1 }}>
              <label style={styles.label}>Email *</label>
              <input
                type="email"
                placeholder="Email"
                required
                style={styles.input}
                value={dataEmail.email}
                onChange={(e) => setDataEmail((prevState) => ({
                  ...prevState,
                  email: e.target.value,
                }))}
              />
            </div>
            <div style={{ flex: 1, minHeight: "50px", maxWidth: isMobile ? "500px" : "235px" }}>
              <label style={{ ...styles.label, marginBottom: "12px" }}>
                Phone Number *
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  border: "1px solid rgba(231, 228, 226, 0.5)",
                  borderRadius: "6px",
                  padding: "0",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Select
                    value={selectedCode}
                    onChange={handleCodeChange}
                    disableUnderline
                    sx={{
                      border: "none",
                      boxShadow: "none",
                      "& fieldset": { border: "none" },
                      minWidth: "40px",
                      padding: "0",
                      display: "flex",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "white",
                      ".MuiSvgIcon-root": { color: "white" },
                    }}
                    inputProps={{ style: { padding: "0 0 0 10px", margin: 0 } }}
                    MenuProps={{ PaperProps: { style: { borderRadius: 8 } } }}
                  >
                    {countryOptions.map((country) => (
                      <MenuItem
                        key={country.code}
                        value={country.code}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "5px",
                          padding: "5px 5px",
                        }}
                      >
                        {/* Wrapper around the flag */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            width: "30px",
                          }}
                        >
                          <img
                            src={country.flagUrl}
                            alt={country.name}
                            style={{ width: "30px", minHeight: "10px" }} // Adjusted flag size
                          />
                        </div>
                      </MenuItem>
                    ))}
                  </Select>
                  <div
                    style={{
                      width: "1px",
                      height: "24px",
                      backgroundColor: "#81A3B8",
                      margin: "0 8px",
                    }}
                  />
                </div>
                <div
                  style={{
                    color: "#FFFFFF",
                    fontSize: "14px",
                    paddingLeft: "10px",
                    paddingRight: "5px",
                  }}
                >
                  {selectedCode}
                </div>
                <input
                  type="text"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value.replace(/\D/g, ""))}
                  style={{
                    border: "none",
                    backgroundColor: "transparent",
                    color: "#FFFFFF",
                    fontSize: "14px",
                    outline: "none",
                    padding: "5px",
                    width: '14px',
                    flex: 1,
                  }}
                  onKeyPress={(e) => {
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                />
              </div>
            </div>
          </div>

          {/* Company Name */}
          <div style={{ marginBottom: "10px" }}>
            <label style={styles.label}>Company name *</label>
            <input
              type="text"
              placeholder="Tennet Depository Indonesia"
              required
              style={styles.input}
              value={dataEmail.company_name}
              onChange={(e) => setDataEmail((prevState) => ({
                ...prevState,
                company_name: e.target.value,
              }))}
            />
          </div>

          {/* Product Inquiry */}
          {/* Product Inquiry */}
          <div style={{ marginBottom: "15px" }}>
            <label
              style={{
                ...styles.label,
                marginBottom: "5px",
                display: "block",
              }}
            >
              What product are you enquiring about? *
            </label>
            <div style={{ display: "flex", gap: "15px" }}>
              {["custody", "xcrow", "OTC"].map((product) => (
                <label
                  key={product}
                  style={{
                    color: "#E7E4E2",
                    display: "flex",
                    alignItems: "center",
                    fontSize: "14px",
                  }}
                >
                  <CustomCheckbox
                    name={product}
                    checked={checkboxState[product]}
                    onChange={handleCheckboxChange}
                  />{" "}
                  {product.charAt(0).toUpperCase() + product.slice(1)}
                </label>
              ))}
            </div>
          </div>

          {/* How can we help? */}
          <div style={{ marginBottom: "10px" }}>
            <label style={styles.label}>How can we help? *</label>
            <textarea
              placeholder="We need..."
              required
              style={styles.textarea}
              value={dataEmail.description}
              onChange={(e) => setDataEmail((prevState) => ({
                ...prevState,
                description: e.target.value,
              }))}
            ></textarea>
          </div>

          {/* Privacy Statement */}
          <div style={{ fontSize: "12px", textAlign: "justify" }}>
            <p>
              Tennet is committed to protecting and respecting your privacy, and
              we’ll only use your personal information to administer your
              account and to provide the products and services you requested
              from us.
            </p>
          </div>

          {/* Send Button
          <button onClick={handleSendEmail} type="submit" style={styles.sendButton}>
            Send message
          </button> */}
        </form>
        {/* Send Button */}
        <button onClick={handleSendEmail} type="submit" style={styles.sendButton}>
          Send message
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
